<template>
  <div class="audioAnalysis_main">
    <div class="audioAnalysis_Content">
      <div class="audioAnalysis_part2">
        <div style="height: 10%">
          <!-- <div class="titleBox">
            <span>设备负载</span>
          </div> -->
          <div class="top">
            <el-select
              class="top-select"
              @change="getSensorHistory"
              filterable
              v-model="$store.state.curElevatorInfo"
              placeholder="请选择"
              :value-key="valueKey"
            >
              <el-option
                v-for="item in elevatorList"
                :key="item.id"
                :label="item.remark"
                :value="item"
              >
              </el-option>
            </el-select>
            <div class="dateP">
              <datePicker
                :disabledDateNum="7"
                :disabledDate="true"
                :dateValue="dateValue"
                align="center"
                @confirmDate="confirmDate"
              />
            </div>
          </div>
        </div>

        <div style="height: 80%; width: 100%; position: relative">
          <div
            style="height: 10%; position: absolute; top: -10px"
            class="m-select"
          >
            <!-- <el-select
              class="top-select"
              @change="getOneSensorHistoryD"
              v-model="curPosition"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cursensorList"
                :key="item.id"
                :label="item.position"
                :value="item.usbPortList"
              ></el-option>
            </el-select> -->
          </div>
          <div style="height: 90%; display: flex">
            <vibration-chart
              style="flex: 4"
              ref="elevatorMotorChart"
              title="温度(°C)"
            />

            <historyTable
              ref="historyTable1"
              style="flex: 2; padding-left: 24px"
              :tableData="historyTableData1"
              :flag="1"
              :isTemp="1"
              @getOneSensorHistory2="getOneSensorHistory2"
              @getOneSensorHistory="getOneSensorHistory"
              @singleLine="singleLine"
              :sensorList="sensorList"
            >
            </historyTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import containerHeader from "@/components/container_header.vue";
import lineChart from "@/components/lineChart.vue";
import pieChart from "@/components/pieChart.vue";
import datePicker from "@/components/datePicker.vue";
import vibrationChart from "@/components/vibration-chart.vue";
import historyTable from "../../../components/historyTable.vue";
import commonUtils from "../../../utils/common";
import axios from "axios";
import { log } from "three";
export default {
  components: {
    containerHeader,
    lineChart,
    pieChart,
    datePicker,
    vibrationChart,
    historyTable,
  },
  data() {
    return {
      sensorHistoryData2: [],
      sensorHistoryData1: [],
      curItem: {},
      popUpShow: false,
      positionStyle: { top: "0px", left: "0px" },
      options: [],
      curElevatorInfo: "",
      filteredData: [],
      elevatorList: [
        { label: "一号电梯", value: 1 },
        { label: "二号电梯", value: 2 },
      ],

      flag: 1, //1是预警列表，2是设备列表,
      warningList: [],
      sensorList: [],
      cursensorList: [],
      //datePick参数
      dateValue: [,],
      maxTime: "",
      minTime: "",
      interval: "",
      curVibrationSensorList: [],
      curMovementSensor: [],
      curElevator: {},
      curlift: "",
      curPosition: "",
      curPosition2: "",
      historyTableData1: [],
      historyTableData2: [],
      valueKey: "id",
      edgeIds:[]
    };
  },
  activated() {
    this.getelevatorList();
    this.curPosition = null;
    this.curPosition2 = null;
  },
  mounted() {
    // this.getelevatorList();
    this.dateValue = [
      //间隔24小时
      new Date(
        new Date().getTime() - 3600 * this.$store.state.timeRange * 1000
      ),
      new Date(),
    ];
    this.maxTime = commonUtils.timeFormat(new Date());
    this.minTime = commonUtils.timeFormat(
      new Date(new Date().getTime() - 3600 * this.$store.state.timeRange * 1000)
    );
  },
  watch: {
    "$store.state.motorTimeRange": function () {
      this.getOneSensorHistory();
    },
    "$store.state.motorTimeRange2": function () {
      this.getOneSensorHistory2();
    },
    "$store.state.curElevatorInfo": function () {
      // this.getelevatorList();
      this.curPosition = null;
      this.curPosition2 = null;
    },

    "$store.state.refreshHistoryData": function () {
      this.getOneSensorHistory();
    },
  },
  methods: {
    singleLine(flag, position, isSingle) {
      //同一个位置再次点击恢复全部曲线
      if (this.$store.state.curposition == position) {
        let curLegendselected1 =
          this.$refs.elevatorMotorChart.$refs.chart.legendselected;
        let curLegendselected2 = this.$refs.elevatorMotorChart2
          ? this.$refs.elevatorMotorChart2.$refs.chart.legendselected
          : "";
        if (flag == 1) {
          Object.keys(curLegendselected1).forEach((key) => {
            if (curLegendselected1[key] === false) {
              curLegendselected1[key] = true;
            }
          });
          this.$refs.elevatorMotorChart.$refs.chart.legendselected =
            curLegendselected1;
          //去掉markLine
          const newData = this.sensorHistoryData1.chartDataY.map((item) => {
            if (item.markLine) {
              item.markLine.data = [];
            }
            return item;
          });
          this.sensorHistoryData1.chartDataY = newData;
          this.$refs.elevatorMotorChart.setData(this.sensorHistoryData1);
        } else {
          Object.keys(curLegendselected2).forEach((key) => {
            if (curLegendselected2[key] === false) {
              curLegendselected2[key] = true;
            }
          });
          this.$refs.elevatorMotorChart2.$refs.chart.legendselected =
            curLegendselected2;
          //去掉markLine
          const newData = this.sensorHistoryData2.chartDataY.map((item) => {
            if (item.markLine) {
              item.markLine.data = [];
            }
            return item;
          });
          this.sensorHistoryData2.chartDataY = newData;
          this.$refs.elevatorMotorChart2.setData(this.sensorHistoryData2);
        }
        return;
      }

      //单个曲线
      let legendselected1 = {};
      let legendselected2 = {};
      this.historyTableData1.forEach((item) => {
        legendselected1[item.position] = isSingle
          ? item.position == position
          : true;
      });
      this.historyTableData2.forEach((item) => {
        legendselected2[item.position] = isSingle
          ? item.position == position
          : true;
      });
      if (flag == 1) {
        this.$refs.elevatorMotorChart.$refs.chart.legendselected =
          legendselected1;
        this.$refs.elevatorMotorChart.$refs.chart.setOptions();
      } else {
        this.$refs.elevatorMotorChart2.$refs.chart.legendselected =
          legendselected2;
        this.$refs.elevatorMotorChart2.$refs.chart.setOptions();
      }
    },
    confirmDate(min, max) {
      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 1 * 1000),
          new Date(),
        ];
        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 1 * 1000)
        );
      }

      const subtract =
        (new Date(this.maxTime).getTime() - new Date(this.minTime).getTime()) /
        1000;
      if (subtract < 3600) {
        this.interval = "5s";
      }
      if (3600 <= subtract && subtract < 24 * 3600) {
        this.interval = "10s";
      }
      if (24 * 3600 <= subtract && subtract < 7 * 24 * 3600) {
        this.interval = "5m";
      }
      if (subtract >= 7 * 24 * 3600) {
        this.interval = "5m";
      }
      this.$store.state.motorTimeRange = "1h";
      this.$store.state.motorTimeRange2 = "1h";
      this.getOneSensorHistoryD();
      this.getOneSensorHistoryD2();
    },

    getOneSensorHistory() {
      // if (this.curVibrationSensorList.length === 0) {
      //   return;
      // }
      //电机负载
      let motorRange = this.$store.state.motorTimeRange;
      const rangeAmount = parseInt(motorRange.substr(0, 1));
      const rangeUnit = motorRange.substr(1, 1);
      let motorInterval = "1m";
      if (motorRange === "1h") {
        motorInterval = "1s";
      } else if (motorRange === "1d") {
        motorInterval = "1m";
      } else if (motorRange === "1w") {
        motorInterval = "5m";
      }
      this.dateValue = [
        //间隔24小时
        this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        this.$moment().format("yyyy-MM-DD HH:mm:ss"),
      ];
      this.minTime = this.$moment()
        .subtract(rangeAmount, rangeUnit)
        .format("yyyy-MM-DD HH:mm:ss");
      this.maxTime = this.$moment().format("yyyy-MM-DD HH:mm:ss");

      let params = {
        interval: motorInterval,
        sensorList: this.curPosition,
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        startTime: this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        // startTime:'2023-07-05 16:53:00',
        endTime: this.$moment().format("yyyy-MM-DD HH:mm:ss"),
        // startTime: this.minTime,
        // endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.sensorHistoryData1 = data;
          this.$refs.elevatorMotorChart.setData(data);
          this.historyTableData1 = res.data.data;
        }
      });
    },
    getOneSensorHistory2() {
      if (this.curVibrationSensorList.length === 0) {
        return;
      }
      //电机负载
      let motorRange = this.$store.state.motorTimeRange2;
      const rangeAmount = parseInt(motorRange.substr(0, 1));
      const rangeUnit = motorRange.substr(1, 1);
      let motorInterval = "1m";
      if (motorRange === "1h") {
        motorInterval = "1s";
      } else if (motorRange === "1d") {
        motorInterval = "5m";
      } else if (motorRange === "1w") {
        motorInterval = "5m";
      }

      this.dateValue = [
        //间隔24小时
        this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        this.$moment().format("yyyy-MM-DD HH:mm:ss"),
      ];
      this.minTime = this.$moment()
        .subtract(rangeAmount, rangeUnit)
        .format("yyyy-MM-DD HH:mm:ss");
      this.maxTime = this.$moment().format("yyyy-MM-DD HH:mm:ss");

      let params = {
        interval: motorInterval,
        sensorList: this.curPosition2,
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        startTime: this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        // startTime:'2023-07-05 16:53:00',
        endTime: this.$moment().format("yyyy-MM-DD HH:mm:ss"),
        // startTime: this.minTime,
        // endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.sensorHistoryData2 = data;
          if (this.$refs.elevatorMotorChart2) {
            this.$refs.elevatorMotorChart2.setData(data);
            this.historyTableData2 = res.data.data;
          }
        }
      });
    },

    getOneSensorHistoryD() {
      // if (this.curVibrationSensorList.length === 0) {
      //   return;
      // }
      const subtract =
        (new Date(this.maxTime).getTime() - new Date(this.minTime).getTime()) /
        1000;
      if (subtract < 3600) {
        this.interval = "1s";
      }
      if (3600 <= subtract && subtract < 24 * 3600) {
        this.interval = "10s";
      }
      if (24 * 3600 <= subtract && subtract < 7 * 24 * 3600) {
        this.interval = "5m";
      }
      if (subtract >= 7 * 24 * 3600) {
        this.interval = "5m";
      }
      //电机负载
      let params = {
        interval: this.interval,
        sensorList: this.curPosition,
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        startTime: this.minTime,
        endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.$refs.elevatorMotorChart.setData(data);
          this.historyTableData1 = res.data.data;
        }
      });
    },
    getOneSensorHistoryD2() {
      if (
        this.curVibrationSensorList.length === 0 ||
        !this.$refs.elevatorMotorChart2
      ) {
        return;
      }
      //电机负载
      const subtract =
        (new Date(this.maxTime).getTime() - new Date(this.minTime).getTime()) /
        1000;
      if (subtract < 3600) {
        this.interval = "1s";
      }
      if (3600 <= subtract && subtract < 24 * 3600) {
        this.interval = "10s";
      }
      if (24 * 3600 <= subtract && subtract < 7 * 24 * 3600) {
        this.interval = "1m";
      }
      if (subtract >= 7 * 24 * 3600) {
        this.interval = "5m";
      }

      let params = {
        interval: this.interval,
        sensorList: this.curPosition2,
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        startTime: this.minTime,
        endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.$refs.elevatorMotorChart2.setData(data);
          this.historyTableData2 = res.data.data;
        }
      });
    },
    getSensorHistory() {
      // this.getelevatorList();
      this.getSensorList(this.$store.state.curElevatorInfo.id);
      this.curPosition = null;
      this.curPosition2 = null;
    },
    //获取传感器列表
    getSensorList(id) {
      const params = {
        elevatorId: id,
      };
      this.$api.sensor.list(params).then((res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          //图表组件延迟加载
          // setTimeout(() => {
          //   this.isInit = true;
          // }, 500);
          this.sensorList = res.data;
          this.curVibrationSensorList = [];
          this.$store.state.curSensorList = res.data;
          //筛选掉sensorType为2的
          this.sensorList = this.sensorList.filter(
            (item) => item.sensorType == 10 
          );
          console.log(this.sensorList);
const aValues = this.sensorList.map(obj => obj.edgeId);
const edgeIds = [...new Set(aValues)];
console.log(edgeIds); 
this.edgeIds  = edgeIds
          const cursensorList = this.sensorList.map((item) => ({
            ...item,
            usbPortList: item.sensorId,
          }));
          this.cursensorList = cursensorList;

          if (this.$store.state.curElevatorInfo.type != "escalator") {
            this.curPosition = this.cursensorList[0].usbPortList;
            console.log(this.cursensorList);
            const usbPortListArray3 = cursensorList.reduce((acc, obj) => {
              if (obj.usbPortList) {
                acc.push(obj.usbPortList);
              }
              return acc;
            }, []);
            const result3 = {
              // id: 99,
              position: "全部",
              usbPortList: usbPortListArray3.join(","),
            };
            cursensorList.push(result3);
            this.curPosition = cursensorList.find(
              (item) => item.position == "全部"
            ).usbPortList;
            if (cursensorList.length == 2) {
              cursensorList.shift();
            }
            this.cursensorList = cursensorList;
          } else {
            const usbPortListArray = cursensorList.reduce((acc, obj) => {
              if (obj.location === 1 && obj.usbPortList) {
                acc.push(obj.usbPortList);
              }
              return acc;
            }, []);

            const result = {
              // id: 98,
              position: "上半区",
              usbPortList: usbPortListArray.join(","),
            };
            const usbPortListArray2 = cursensorList.reduce((acc, obj) => {
              if (obj.location === 2 && obj.usbPortList) {
                acc.push(obj.usbPortList);
              }
              return acc;
            }, []);

            const result2 = {
              // id: 99,
              position: "下半区",
              usbPortList: usbPortListArray2.join(","),
            };

            const usbPortListArray3 = cursensorList.reduce((acc, obj) => {
              if (obj.usbPortList) {
                acc.push(obj.usbPortList);
              }
              return acc;
            }, []);
            const result3 = {
              // id: 99,
              position: "全部",
              usbPortList: usbPortListArray3.join(","),
            };
            cursensorList.push(result);
            cursensorList.push(result2);
            cursensorList.push(result3);

            this.curPosition = cursensorList.find(
              (item) => item.position == "上半区"
            ).usbPortList;
            this.curPosition2 = cursensorList.find(
              (item) => item.position == "下半区"
            ).usbPortList;

            this.cursensorList = cursensorList;
          }

          this.sensorList.forEach((item) => {
            if (item.sensorType === 1 || item.sensorType == 8) {
              this.curVibrationSensorList.push(item.sensorId);
            } else if (item.sensorType === 2) {
              this.curMovementSensor = item.sensorId;
            }
          });
          console.log(this.sensorList);
          this.getOneSensorHistory();
          // this.getOneSensorHistory2();

          // this.getOneSensorHistory();

          // this.$store.commit("$_setCurSensorList", res.data);
          // const newList = this.countSensorByPosition(res.data);
          // this.$store.commit("$_setSensorClassificationList", newList);

          //定时刷新全部图表;
          //默认取最近一小时的时间
          //先执行一次u
          // this.getSensorHistoryTimerTask();
          // this.timer = setInterval(() => {
          //     this.getSensorHistoryTimerTask();
          // }, 30000);
        } else {
          this.sensorList = [];
        }
      });
    },

    requestMotorHistoryData() {
      if (this.curVibrationSensorList.length === 0) {
        return;
      }
      //电机负载
      let motorRange = this.$store.state.motorTimeRange;
      const rangeAmount = parseInt(motorRange.substr(0, 1));
      const rangeUnit = motorRange.substr(1, 1);
      let motorInterval = "1m";
      if (motorRange === "1h") {
        motorInterval = "1s";
      } else if (motorRange === "1d") {
        motorInterval = "1m";
      } else if (motorRange === "1w") {
        motorInterval = "5m";
      }
      this.dateValue = [
        //间隔24小时
        this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        this.$moment().format("yyyy-MM-DD HH:mm:ss"),
      ];
      this.minTime = this.$moment()
        .subtract(rangeAmount, rangeUnit)
        .format("yyyy-MM-DD HH:mm:ss");
      this.maxTime = this.$moment().format("yyyy-MM-DD HH:mm:ss");

      let params = {
        interval: motorInterval,
        sensorList: this.curVibrationSensorList.join(","),
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        startTime: this.$moment()
          .subtract(rangeAmount, rangeUnit)
          .format("yyyy-MM-DD HH:mm:ss"),
        // startTime:'2023-07-05 16:53:00',
        endTime: this.$moment().format("yyyy-MM-DD HH:mm:ss"),
        // startTime: this.minTime,
        // endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.$refs.elevatorMotorChart.setData(data);
        }
      });
    },

    //获取传感器列表

    requestMotorHistoryData2() {
      if (this.curVibrationSensorList.length === 0) {
        return;
      }
      //电机负载
      let motorRange = this.$store.state.motorTimeRange;
      const rangeAmount = parseInt(motorRange.substr(0, 1));
      const rangeUnit = motorRange.substr(1, 1);
      let motorInterval = "1m";
      if (motorRange === "1h") {
        motorInterval = "1s";
      } else if (motorRange === "1d") {
        motorInterval = "1m";
      } else if (motorRange === "1w") {
        motorInterval = "5m";
      }
      let params = {
        interval: motorInterval,
        sensorList: this.curVibrationSensorList.join(","),
        dataType: 10,
        elevatorId: this.$store.state.curElevatorInfo.id,
        edgeId: this.edgeIds[0],
        // startTime: this.$moment()
        //   .subtract(rangeAmount, rangeUnit)
        //   .format("yyyy-MM-DD HH:mm:ss"),
        // startTime:'2023-07-05 16:53:00',
        // endTime: this.$moment().format("yyyy-MM-DD HH:mm:ss"),
        startTime: this.minTime,
        endTime: this.maxTime,
      };
      this.$api.sensor.sensorHistory(params).then((res) => {
        if (res.code === "200") {
          const data = this.SensorHistoryToEchartData(10, res.data);
          this.$refs.elevatorMotorChart.setData(data);
        }
      });
    },
    SensorHistoryToEchartData(dataType, data) {
      //次数
      if (dataType == 5) {
        const chartDataX = data.time;
        const chartDataY = data.counts;
        return { chartDataX, chartDataY };
      }

      //倾角
      if (dataType == 4) {
        const chartDataX = data.time;
        const chartDataY = [
          {
            type: "line",
            name: "x",
            data: data.x,
            showSymbol: false,
            color: "#e6a23c",
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#e6a23c80",
                },
                {
                  offset: 1,
                  color: "#e6a23c",
                },
              ]),
            },
          },
          {
            type: "line",
            name: "y",
            data: data.y,
            showSymbol: false,
            itemStyle: {
              color: "#00d1ed",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00d1ed",
                },
                {
                  offset: 1,
                  color: "#00d1eda3",
                },
              ]),
            },
          },
        ];

        let legendData = [];
        if (chartDataX && chartDataX.length != 0) {
          legendData = ["x", "y"];
        }

        return { chartDataX, chartDataY, legendData };
      }

      //里程
      if (dataType === 3) {
        const chartDataX = data.time;
        const chartDataY = data.distances;
        return { chartDataX, chartDataY };
      }

      //速度
      if (dataType === 2) {
        const chartDataX = data.time;
        const chartDataY = data.speed;
        return { chartDataX, chartDataY };
      }

      //振动传感器
      if (dataType === 1) {
        const chartDataX = data.time;
        const chartDataY = !data.data
          ? null
          : data.data.map((item, index) => {
              if (item.position == this.$store.state.curposition) {
                return {
                  type: "line",
                  name: item.position,
                  data: item.energy,
                  showSymbol: false,
                  markLine: {
                    symbol: "none",
                    data: [
                      {
                        // symbol:false,
                        yAxis: item.ninetyFive,
                        lineStyle: {
                          // color: 'red',
                          type: "dashed",
                          width: 1,
                        },
                        name: "参考值",
                        label: {
                          position: "middle",
                          color: "inherit",
                          formatter: "参考值:" + "{c}",
                        },
                      },
                    ],
                  },
                };
              } else {
                return {
                  type: "line",
                  name: item.position,
                  data: item.energy,
                  showSymbol: false,
                };
              }
            });
        let legendData = [];
        if (data.time && data.time.length != 0) {
          data.data.forEach((item) => {
            legendData.push(item.position);
          });
        }
        return { chartDataX, chartDataY, legendData };
      }
      //温度
      if (dataType === 10) {
        const chartDataX = data.time;
        const chartDataY = !data.data
          ? null
          : data.data.map((item, index) => {
              if (item.position == this.$store.state.curposition) {
                return {
                  type: "line",
                  name: item.position,
                  data: item.temper,
                  showSymbol: false,
                  markLine: {
                    symbol: "none",
                    data: [
                      {
                        // symbol:false,
                        yAxis: item.reference,
                        lineStyle: {
                          // color: 'red',
                          type: "dashed",
                          width: 1,
                        },
                        name: "参考值",
                        label: {
                          position: "middle",
                          color: "inherit",
                          formatter: "参考值:" + "{c}",
                        },
                      },
                    ],
                  },
                };
              } else {
                return {
                  type: "line",
                  name: item.position,
                  data: item.temper,
                  showSymbol: false,
                };
              }
            });
        let legendData = [];
        if (data.time && data.time.length != 0) {
          data.data.forEach((item) => {
            legendData.push(item.position);
          });
        }
        return { chartDataX, chartDataY, legendData };
      }
    },

    getelevatorList() {
        const params = {
          isTemper: 1
        }
      this.$api.elevator.list(params).then((res) => {
        if (res.code == 200) {
          this.elevatorList = res.data;
          this.$store.state.curElevatorInfo = this.elevatorList[0]
          if (this.$store.state.curElevatorInfo == "") {
            this.$store.state.curElevatorInfo = this.elevatorList[0];
          }

          this.getSensorList(this.$store.state.curElevatorInfo.id);
        }
      });
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.audioAnalysis_main {
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;

  /deep/ .el-input__inner {
    height: 2.5rem !important;
    font-size: 0.875rem !important;
  }

  .m-select {
    /deep/ .el-input__inner {
      border: none;
      background: transparent;
      color: rgb(104, 216, 254);
    }

    /deep/ .el-select .el-input .el-input__inner {
      width: 8.2rem;
    }

    /deep/ .el-select > .el-input {
      width: 8.2rem;
    }
  }
}

.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0rem 0rem 1.5rem;
  border-left: 1px rgb(68, 215, 182) solid;

  span {
    width: 4rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgb(68, 215, 182);
    line-height: 1.125rem;
    padding-left: 1.25rem;
  }
}

.audioAnalysis_Content {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .el-input__inner {
    width: 13.4375rem;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .el-select {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
  }

  .el-input {
    width: 13.4375rem !important;
    height: 2.5rem !important;
    line-height: 2.5rem !important;
    font-size: 0.9375rem !important;
  }

  .audioAnalysis_part2 {
    background: var(--cardbg-color);
    flex: 1;
    height: 100%;
    width: 100%;

    .top {
      padding: 1.375rem;
      display: flex;
      align-items: center;
    }

    .dateP {
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;

      /deep/ .el-date-editor .el-range__close-icon {
        line-height: 1.5rem;
      }

      /deep/ .el-input__icon {
        width: 1.5625rem;
      }

      /deep/ .el-range-editor--small .el-range-input {
        font-size: 0.875rem;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        line-height: 1.875rem;
        font-size: 0.8125rem;
      }

      /deep/ .el-date-editor .el-range__icon {
        line-height: 1.5rem;
        font-size: 0.875rem;
      }

      /deep/ .el-radio-button__inner {
        background: rgba(8, 17, 24, 0.21);
        border: 0.125rem solid #c0e9ff !important;

        color: #c0e9ff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        border: 0.125rem solid #244447 !important;
      }

      /deep/ .el-icon-time:before {
        color: #244447;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border: 0.125rem solid #d3fbff;
        background: rgba(211, 251, 255, 0.5);
        box-shadow: -0.0625rem 0 0 0 #d3fbff;
      }

      /deep/ .el-range-editor--small.el-input__inner {
        height: 2.5rem !important;
        width: 24.0625rem !important;
        background: var(--input-bg) !important;
      }

      /deep/ .el-range-editor--small .el-range-input {
        background: transparent;
      }

      /deep/ .el-range-editor--small .el-range-separator {
        color: #d3fbff;
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .audioAnalysis_main {
    width: 100%;
    height: 100%;
    font-size: 24px;
    z-index: 15;
    overflow: auto;
    box-sizing: border-box;
    display: flex;

    /deep/ .el-input__inner {
      height: 40px !important;
      font-size: 14px !important;
    }

    .m-select {
      /deep/ .el-input__inner {
        border: none;
        background: transparent;
      }

      /deep/ .el-select .el-input .el-input__inner {
        width: 120px;
      }

      /deep/ .el-select > .el-input {
        width: 120px;
      }
    }
  }

  .audioAnalysis_Content {
    flex: 2.5;
    display: flex;
    flex-direction: column;

    .el-select {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
    }

    .el-input__inner {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .el-input {
      width: 215px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 15px !important;
    }

    .titleBox {
      display: flex;
      align-items: center;
      margin: 13px 0px 0px 24px;
      border-left: 1px rgb(68, 215, 182) solid;

      span {
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: rgb(68, 215, 182);
        line-height: 18px;
        padding-left: 20px;
      }
    }

    .audioAnalysis_part2 {
      background: var(--cardbg-color);
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;

      .top {
        padding: 22px;
        display: flex;
        align-items: center;
      }

      .dateP {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 20px;

        /deep/ .el-date-editor .el-range__close-icon {
          line-height: 24px;
        }

        /deep/ .el-input__icon {
          width: 25px;
        }

        /deep/ .el-range-editor--small .el-range-input {
          font-size: 14px;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          line-height: 30px;
          font-size: 13px;
        }

        /deep/ .el-date-editor .el-range__icon {
          line-height: 24px;
          font-size: 14px;
        }

        /deep/ .el-radio-button__inner {
          background: rgba(8, 17, 24, 0.21);
          border: 2px solid #c0e9ff !important;

          color: #c0e9ff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          border: 2px solid #244447!important;
        }

        /deep/ .el-icon-time:before {
          color: #244447;
        }

        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          border: 2px solid #d3fbff;
          background: rgba(211, 251, 255, 0.5);
          box-shadow: -1px 0 0 0 #d3fbff;
        }

        /deep/ .el-range-editor--small.el-input__inner {
          height: 40px !important;
          width: 385px !important;
          background: var(--input-bg) !important;
        }

        /deep/ .el-range-editor--small .el-range-input {
          background: transparent;
        }

        /deep/ .el-range-editor--small .el-range-separator {
          color: #d3fbff;
        }
      }
    }
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/home/temperature/index.vue